import React, { FunctionComponent, useEffect } from 'react';

import Header from '../../../components/Header';
import { useHistory } from 'react-router-dom';
import Helpline from '../../../components/Helpline';
import Overview from '../../../components/Fastag/Passbook/Overview';
import Transactions from '../../../components/Fastag/Passbook/Transactions';
import { ListingWrapper } from '../../../components/_globalStyled';
import { sendEvent2 } from '../../../utils/tracking';

const Passbook: FunctionComponent = () => {
  const history = useHistory();
  useEffect(() => {
    sendEvent2(
      'screen_view',
      {
        event_action: 'view',
        screen_name: 'ft_passbook',
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
  }, []);
  return (
    <div>
      <Header title="Fastag" link="/portal/fastag" history={history}>
        <Helpline loneElement={true} />
      </Header>
      <div>
        <Overview />
      </div>
      <ListingWrapper>
        <div className="container mt5">
          <Transactions />
        </div>
      </ListingWrapper>
    </div>
  );
};

export default Passbook;
